import script from "./UserMessageAuthorName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageAuthorName.vue?vue&type=script&lang=js"
export * from "./UserMessageAuthorName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageAuthorName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/user-message/UserMessageAuthorName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65dccbe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65dccbe5', __exports__)) {
    api.reload('65dccbe5', __exports__)
  }
  
}


export default __exports__